import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import { Checkbox } from "../../../components/ui/Checkbox";
import Icon from "../../../components/AppIcon";
import axios from "axios";
import { toast } from "react-toastify";
import * as URLS from "../../../../urls";
import { useSelector, useDispatch } from "react-redux";
import { getProvincesService } from "redux/services/general_service";

const RegistrationForm = ({ onRegisterSuccess }) => {
  const { t ,i18n } = useTranslation();
  const dispatch = useDispatch();
  const { countries } = useSelector((state) => state.general);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
  //  email: "",
    password: "",
    phone: "",
    country_id: "", // New state for country
    province_id: "", // New state for province
  });

  const [provinces, setProvinces] = useState([]); // State for provinces
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");

  // Fetch provinces when country_id changes
  useEffect(() => {
    if (formData.country_id) {
      dispatch(getProvincesService(formData.country_id))
        .then((response) => {
          setProvinces(response.payload?.data?.data); // Assuming response.data contains the provinces
        })
        .catch((error) => {
          console.error("Error fetching provinces:", error);
          toast.warn(t("errorFetchingProvinces"));
        });
    } else {
      setProvinces([]); // Clear provinces if no country is selected
    }
  }, [formData.country_id, dispatch, t]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.first_name.trim()) {
      newErrors.first_name = t("firstNameRequired");
    }

    if (!formData.last_name.trim()) {
      newErrors.last_name = t("lastNameRequired");
    }


    if (!formData.password) {
      newErrors.password = t("passwordRequired");
    } else if (formData.password.length < 8) {
      newErrors.password = t("password") + " must be at least 8 characters";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = t("confirrmPasswordRequired");
    } else if (formData.password !== confirmPassword) {
      newErrors.confirmPassword = t("passwordsDoNotMatch");
    }

    if (formData.phone && !/^\+?[\d\s\-\(\)]+$/.test(formData.phone)) {
      newErrors.phone = "Please enter a valid phone number";
    }

   /* if (!formData.country_id) {
      newErrors.country_id = t("country") + " is required";
    }

    if (!formData.province_id) {
      newErrors.province_id = t("province") + " is required";
    }*/

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${URLS.baseUrl}/${URLS?.registerURL}`,
        formData
      );
      if (response?.status === 200) {
        localStorage.setItem("Token", response?.data?.data?.token);
        localStorage.setItem("isAuthenticated", "true");
        localStorage.setItem(
          "permissions",
          JSON.stringify(response?.data?.data?.user?.permissions)
        );
        localStorage.setItem(
          "user",
          JSON.stringify({
            id: response.data.data?.user?.id,
            first_name: response.data.data?.user?.first_name,
            last_name: response.data.data?.user?.last_name,
         //   email: response.data.data?.user?.email,
          })
        );
        toast.success(t("registered_successfully"));
        onRegisterSuccess(response.data.data.user); // Pass user data to parent
        navigate("/");
      } else {
        response?.payload?.errors?.map((error) => toast.warn(error));
      }
    } catch (error) {
      console.log(error?.response?.data?.errors);
      toast.warn(t("submitError"));
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* First Name */}
        <Input
          label={t("firstName")}
          type="text"
          name="first_name"
          value={formData.first_name}
          onChange={handleInputChange}
          placeholder={t("firstName")}
          error={errors.first_name}
          required
        />

        {/* Last Name */}
        <Input
          label={t("lastName")}
          type="text"
          name="last_name"
          value={formData.last_name}
          onChange={handleInputChange}
          placeholder={t("lastName")}
          error={errors.last_name}
          required
        />


        {/* Password */}
        <div className="relative">
          <Input
            label={t("password")}
            type={showPassword ? "text" : "password"}
            name="password"
            value={formData.password}
            onChange={handleInputChange}
            placeholder={t("password")}
            error={errors.password}
            required
          />
       <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className={`absolute ${
              i18n.language === "ar" ? "left-3" : "right-3"
            } top-9 text-text-secondary hover:text-text-primary transition-smooth`} // تغيير الموضع بناءً على اللغة
         
          >
            <Icon name={showPassword ? "EyeOff" : "Eye"} size={18} />
          </button>
        </div>

        {/* Confirm Password */}
        <div className="relative">
          <Input
            label={t("confirmPassword")}
            type={showConfirmPassword ? "text" : "password"}
            name="confirmPassword"
            value={confirmPassword}
            onChange={(e) => {
              setConfirmPassword(e.target.value);
              if (errors.confirmPassword) {
                setErrors((prev) => ({
                  ...prev,
                  confirmPassword: "",
                }));
              }
            }}
            placeholder={t("confirmPassword")}
            error={errors.confirmPassword}
            required
          />
          <button
            type="button"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
           className={`absolute ${
              i18n.language === "ar" ? "left-3" : "right-3"
            } top-9 text-text-secondary hover:text-text-primary transition-smooth`} 
          >
            <Icon name={showConfirmPassword ? "EyeOff" : "Eye"} size={20} />
          </button>
        </div>

        {/* Phone Number */}
        <Input
          label={t("phone")}
          type="tel"
          name="phone"
          value={formData.phone}
          onChange={handleInputChange}
          //   placeholder="+1 (555) 123-4567"
          error={errors.phone}
        />

        {/* Country Selection */}
        <div className="mb-6">
          <label
            htmlFor="country"
            className="block text-sm font-semibold text-gray-800 mb-2"
          >
            {t("country")}
          </label>
          <select
            name="country_id"
            value={formData.country_id}
            onChange={handleInputChange}
            className={`block w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200 ease-in-out hover:border-blue-400`}
            
          >
            <option value="" disabled>
              {t("selectCountry")}
            </option>
            {countries.map((country) => (
              <option key={country.id} value={country.id}>
                {country.translations?.ar?.name}
              </option>
            ))}
          </select>
    
        </div>

        {/* Province Selection */}
        <div className="mb-6">
          <label
            htmlFor="province_id"
            className="block text-sm font-semibold text-gray-800 mb-2"
          >
            {t("province")}
          </label>
          <select
            name="province_id"
            value={formData.province_id}
            onChange={handleInputChange}
            className={`block w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200 ease-in-out hover:border-blue-400`}
            
          >
            <option value="" disabled>
              {t("selectProvince")}
            </option>
            {provinces.map((province) => (
              <option key={province.id} value={province.id}>
                {province.name}
              </option>
            ))}
          </select>
          {errors.province && (
            <p className="text-red-500 text-sm mt-1">{errors.province}</p>
          )}
        </div>

        {/* Submit Error */}
        {errors.submit && (
          <div className="p-3 bg-error/10 border border-error/20 rounded-lg">
            <p className="text-sm text-error">{errors.submit}</p>
          </div>
        )}

        {/* Submit Button */}
        <Button
          type="submit"
          variant="default"
          size="lg"
          fullWidth
          loading={isLoading}
          disabled={isLoading}
        >
          {isLoading ? t("loading...") : t("createAccount")}
        </Button>
      </form>
    </div>
  );
};

export default RegistrationForm;
